export default "__VITE_ASSET__fb0d9ca3__"